import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { ReferralStatusConsequenceBadges } from './referralStatusConsequences';
import { useTableScrollDismiss } from '../../../components/inbox/TableScrollContext';

const statusLabel = (status) => `${status.name}${status.active === false ? ' (Deactivated)' : ''}`;

const ReferralStatusSelect = ({
  statuses,
  value,
  onChange,
  onClick,
}) => {
  const [open, setOpen] = useState(false);
  useTableScrollDismiss(() => setOpen(false));

  return (
    <Select
      style={{ width: '75%' }}
      value={value}
      onClick={onClick}
      optionLabelProp="label"
      dropdownMatchSelectWidth={false}
      dropdownClassName="referral-status-consequence-dropdown"
      open={open}
      onDropdownVisibleChange={setOpen}
      onChange={(selectedId) => {
        const selectedStatus = statuses.find((status) => status.id === selectedId);
        if (selectedStatus) onChange(selectedStatus);
      }}
    >
      {statuses
        .filter((status) => status.active !== false || status.id === value)
        .map((status) => (
          <Select.Option
            key={status.id}
            value={status.id}
            disabled={status.active === false}
            style={status.active === false ? { color: '#999' } : {}}
            label={statusLabel(status)}
          >
            <span className="referral-status-option-row">
              <span className="referral-status-option-row__name">{statusLabel(status)}</span>
              <ReferralStatusConsequenceBadges status={status} />
            </span>
          </Select.Option>
        ))}
    </Select>
  );
};

ReferralStatusSelect.propTypes = {
  statuses: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

ReferralStatusSelect.defaultProps = {
  statuses: [],
  value: null,
  onClick: () => {},
};

export default ReferralStatusSelect;
